export default {
  print: (state) => {
    return state.print;
  },

  reportInfo: (state) => {
    return state.reportInfo;
  },

  reportInfoLog: (state) => {
    return state.reportInfoLog;
  },

  reportInfoDropDown: (state) => {
    return state.reportInfoDropDown;
  },

  reportInfoOptions: (state) => {
    const reportInfoOptions = [];
    state.reportInfoDropDown.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.title,
        text: item.title,
        isDefault: item.isDefault,
        reportInfoId: item.reportInfoId,
        reportInfoBranchId: item.reportInfoBranchId,
        key: item.key,
      };
      reportInfoOptions.push(pushItem);
    }
    return reportInfoOptions;
  },
};
